<script setup lang="ts">
import TechnoFrame from "@/components/Common/TechnoFrame.vue";
</script>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'TestDescription',

    data() {
        return {
        }
    },
})
</script>

<template>
    <div class="description">
        <TechnoFrame
            :offset="5"
            :size-modifier="0.3"
        />

        <div class="contentHolder">
            <div class="text">
                <p>Что такое <span class="highlighted">закрытый бета-тест</span>?</p>
                <p><span class="highlighted">ЗБТ</span> - это первоначальная версия игры, запущенная для ограниченного числа участников.</p>
                <p>Поскольку на этой стадии игра ещё содержит некоторые баги и недочёты, игровой процесс может быть не вполне стабильным. Игроки, участвующие в тестировании, могут обнаружить ошибки и сообщить о них администрации игры. Также участники тестирования могут выдвигать идеи и предложения, касающиеся улучшения любых аспектов игры: от расположения кнопок до ключевых игровых механик.</p>
                <p>Чтобы поучаствовать в <span class="highlighted">ЗБТ</span>, нужно приобрести пропуск. Сделать это можно на странице <router-link to="register" class="highlighted">регистрации</router-link>.</p>
                <p><span class="highlighted">Участники ЗБТ</span> - это Первопроходцы, которые вносят неоценимый вклад в развитие проекта.</p>
                <p>Присоединяйся к эксклюзивному <span class="highlighted">закрытому бета-тестированию</span>!</p>

                <ul>
                    <li>Возможность первым протестировать новые игровые механики и функции</li>
                    <li>Отправляйся в путешествие по неизведанным мирам и разгадывай их тайны</li>
                    <li>Взаимодействуй с живыми игроками и обменивайся опытом</li>
                    <li>Близкое общение с разработчиками, всегда открытыми к диалогу и готовыми выслушать твоё мнение. Оно действительно важно!</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.description {
    position: relative;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 10px;
    box-shadow: 0 0 5px 1px rgba(0, 0, 0, 0.6);
    width: 1000px;
    color: white;
    font-size: 16px;

    background-image: v-bind('`url("/img/page/landing/main/bg/7.webp")`');
    background-size: cover;
    background-position: bottom center;
}

.contentHolder {
    width: 100%;
    padding: 30px 50px 40px 50px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-evenly;
}

.text {
    background: rgba(0, 0, 0, 0.6);
    border-radius: 10px;
    box-shadow: 0 0 10px 2px black;
    padding: 5px 10px 5px 10px;
}

p {
    //text-shadow: 0 0 3px rgba(0, 0, 0, 0.9);
    margin-bottom: 7px;
}

ul {
    margin: 0;
}

span {
    &.highlighted {
        color: orange;
    }
}
</style>
